import { useState } from "react";
import { ELEMENT_LIST } from "@/lib/atomElements";

interface ElementSearchDropdownProps {
  selectedElementN: number;
  onSelect: (elementN: number) => void;
  className?: string;
}

export function ElementSearchDropdown({
  selectedElementN,
  onSelect,
  className = "",
}: ElementSearchDropdownProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  // Filter elements by name, symbol, or atomic number
  const filteredElements = ELEMENT_LIST.filter(
    (el) =>
      el.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.symbol.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.atomicNumber.toString().includes(searchQuery)
  );

  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => {
          setSearchQuery(e.target.value);
          setShowSearchDropdown(e.target.value.length > 0);
        }}
        onFocus={() => setShowSearchDropdown(searchQuery.length > 0)}
        onBlur={() => setTimeout(() => setShowSearchDropdown(false), 200)}
        placeholder="Search elements..."
        className="w-full rounded-lg border border-slate-700 bg-slate-800 px-4 py-2 text-sm text-white placeholder-slate-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      />
      {showSearchDropdown && (
        <div className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-slate-700 bg-slate-800 shadow-lg">
          {filteredElements.slice(0, 8).map((el) => (
            <button
              key={el.symbol}
              type="button"
              onClick={() => {
                onSelect(el.atomicNumber);
                setSearchQuery("");
                setShowSearchDropdown(false);
              }}
              className="w-full px-4 py-2 text-left hover:bg-slate-700 focus:outline-none block"
            >
              <span className="font-medium text-white">{el.symbol}</span>
              <span className="ml-2 text-slate-400">{el.name}</span>
              <span className="ml-2 text-xs text-slate-500">({el.atomicNumber})</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
